<template>
  <div>
    <validation-observer ref="editForm">
      <b-row class="mt-2">
        <b-col md="4">
          <b-card :title="$t('objects.object_photo')">
            <b-row>
              <b-col
                v-if="GET_ONE_OBJECT.image"
                cols="12"
              >
                <b-card bg-variant="light">
                  <b-img
                    :src="GET_ONE_OBJECT.image.url"
                    fluid
                    alt="Responsive image"
                  />
                  <div class="d-flex justify-content-around mt-1">
                    <b-button
                      size="sm"
                      variant="warning"
                      @click="updateImage"
                    >
                      <feather-icon icon="EditIcon" /> {{ $t('objects.refresh') }}
                    </b-button>
                    <b-form-file
                      ref="imageFileInput"
                      v-model="GET_ONE_OBJECT.file"
                      plain
                      class="d-none"
                      :browse-text="$t('objects.choose_room_layouts')"
                      @input="fileChanged"
                    />
                    <b-button
                      id="delete-img-button"
                      size="sm"
                      variant="danger"
                    >
                      <feather-icon icon="TrashIcon" /> {{ $t('generals.delete') }}
                    </b-button>
                    <b-popover
                      target="delete-img-button"
                      triggers="focus"
                      placement="top"
                      variant="danger"
                      :title="$t('objects.delete_picture')"
                      :show.sync="delete_img_popover"
                    >
                      <div class="d-flex justify-content-around">
                        <b-button
                          size="sm"
                          @click="deleteImage"
                        >
                          {{ $t('generals.ok') }}
                        </b-button>
                        <b-button
                          size="sm"
                          @click="delete_img_popover = false"
                        >
                          {{ $t('generals.no') }}
                        </b-button>
                      </div>
                    </b-popover>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <b-form-group v-if="!GET_ONE_OBJECT.image">
              <label>{{ $t('objects.image') }}</label>
              <b-form-file
                v-model="obj.file"
                :placeholder="$t('objects.select_image')"
                :drop-placeholder="$t('objects.drag_file_here')"
                :browse-text="$t('objects.select')"
                @input="fileChanged"
              />
            </b-form-group>
          </b-card>
          <b-card :title="$t('objects.location')">
            <b-button
              v-b-modal.map-modal
              class="mx-auto mb-2"
              variant="primary"
            >
              <feather-icon
                icon="MapPinIcon"
              />
              {{ $t('objects.mark_on_map') }}
            </b-button>
            <validated-form
              :def_form_obj="GET_ONE_OBJECT"
              :form_fields="getLocationFields"
            />
          </b-card>
          <b-card :title="$t('navbars.project_staff')">
            <v-select
              v-model="obj.built_by"
              :options="GET_PROJECT_STAFF.results"
              :get-option-label="opt => opt.full_name[$i18n.locale]"
              multiple
              :reduce="option => option.id"
            />
          </b-card>
        </b-col>
        <b-col md="8">
          <b-card :title="$t('objects.information')">
            <validated-form
              :def_form_obj="GET_ONE_OBJECT"
              :form_fields="getParametrFields"
            />
          </b-card>
          <b-card :title="$t('objects.infrastructure')">
            <b-row>
              <b-col md="6">
                <validated-form
                  :form_fields="getInfrastructureFields"
                  :def_form_obj="obj"
                />
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label>{{ $t('objects.parking_space') }}</label>
                  <b-form-checkbox-group
                    v-model="obj.parking"
                    :options="GET_PARKING_OPTIONS"
                    class="mt-50"
                    :stacked="true"
                    :text-field="`title.${this.$i18n.locale}`"
                    value-field="id"
                    @change="parkingChange"
                  />
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col
                md="12"
                class="mt-1 justify-content-end"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="saveObject"
                >
                  {{ $t('generals.save') }}
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  @click="$router.push({ name: 'object-view', params: { id: $route.params.id } })"
                >
                  {{ $t('generals.back') }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
    <b-modal
      id="map-modal"
      :title="$t('objects.mark_on_map')"
      :ok-title="$t('generals.save')"
      size="lg"
      :cancel-title="$t('generals.cancel')"
      @ok="mapSaved"
    >
      <leaflet-map
        :position="obj.position"
        @position="setNewLocation"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BFormGroup, BButton, BModal, BImg, BFormFile, BPopover, BFormCheckboxGroup,
  // BFormInput,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import leafletMap from '@/components/map.vue'
import validatedForm from '@/components/validatedForm.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    FeatherIcon,
    BModal,
    leafletMap,
    ValidationObserver,
    validatedForm,
    BFormFile,
    // BFormInput,
    BImg,
    BPopover,
    BFormCheckboxGroup,
    vSelect,
  },
  data() {
    return {
      selectedRadio: 'active',
      required,
      delete_img_popover: false,
      obj: {},
      content_type_id: null,
      optionsRadio: [
        { text: 'Жилой комплекс', id: 1 },
        { text: 'Микрорайон', id: 2 },
        { text: 'Квартал', id: 3 },
      ],
      structure_options: [
        { text: 'Охрана', value: 'orange' },
        { text: 'Спортивная площадка', value: 'apple' },
        { text: 'Детская площадка', value: 'pineapple' },
        { text: 'Школа', value: 'grape' },
        { text: 'Детский сад', value: 'grapes' },
      ],
      currency_options: [
        { title: 'Узбекский сум', id: 1 },
      ],
      options: [
        { text: 'Нет', value: 'first' },
        { text: 'Подземная', value: 'second' },
        { text: 'Наземная', value: 'third' },
      ],
    }
  },
  computed: {
    ...mapGetters('objects', ['GET_ONE_OBJECT', 'GET_OBJECT_TYPES', 'GET_OBJECT_INFRASTRUCTURES', 'GET_PARKING_OPTIONS']),
    ...mapGetters('knowledgeBase', ['GET_REGIONS', 'GET_DISTRICTS', 'GET_CURRENCIES', 'GET_SALE_OFFICES', 'GET_CONSTRUCTORS',
      'GET_ONE_CONSTRUCTOR', 'GET_PROJECT_STAFF']),
    ...mapGetters('files', ['GET_ONE_ATTACHMENT']),
    getParametrFields() {
      return [
        {
          col_size: 12,
          obj_name: 'title',
          validation_rules: 'required',
          label: this.$t('objects.name_object'),
          placeholder: this.$t('objects.name_object'),
          props: {
            size: 'lg',
          },
        },
        {
          component_name: 'b-form-radio-group',
          col_size: 12,
          obj_name: 'object_type',
          validation_rules: 'required',
          label: this.$t('objects.type_object'),
          placeholder: this.$t('objects.type_object'),
          props: {
            options: this.GET_OBJECT_TYPES,
            class: 'mt-50',
            'button-variant': 'outline-primary',
            'value-field': 'id',
            'text-field': `name.${this.$i18n.locale}`,
          },
        },
        {
          component_name: 'v-select',
          col_size: 4,
          obj_name: 'currency',
          validation_rules: 'required',
          label: this.$t('objects.currency'),
          placeholder: this.$t('objects.currency'),
          props: {
            options: this.GET_CURRENCIES,
            getOptionLabel: option => option.title[this.$i18n.locale],
            reduce: option => option.id,
            disabled: true,
          },
        },
        {
          component_name: 'v-select',
          col_size: 8,
          obj_name: 'sale_office',
          label: this.$t('objects.salas_office'),
          placeholder: this.$t('objects.salas_office'),
          props: {
            label: 'title',
            options: this.GET_SALE_OFFICES,
            reduce: option => option.id,
          },
        },
        {
          col_size: 6,
          obj_name: 'brand',
          // validation_rules: 'required',
          component_name: 'v-select',
          label: this.$t('objects.developer_brand'),
          placeholder: this.$t('objects.developer_brand'),
          props: {
            label: 'title',
            options: this.GET_CONSTRUCTORS,
            reduce: option => option.id,
          },
        },
        {
          col_size: 6,
          obj_name: 'site',
          // validation_rules: 'required',
          label: this.$t('objects.site'),
          placeholder: this.$t('objects.site'),
        },
        // {
        //   col_size: 12,
        //   obj_name: 'bank',
        //   label: this.$t('objects.bank'),
        //   placeholder: this.$t('objects.bank'),
        // },
        {
          component_name: 'v-select',
          col_size: 12,
          obj_name: 'bank',
          label: this.$t('references.rs'),
          // placeholder: this.$t('references.rs'),
          props: {
            label: 'bank_name',
            options: this.GET_ONE_CONSTRUCTOR.account.banks,
          },
        },
        {
          component_name: 'b-form-textarea',
          label: this.$t('objects.description'),
          placeholder: this.$t('objects.description'),
          obj_name: 'description',
        },
      ]
    },
    getLocationFields() {
      return [
        {
          component_name: 'v-select',
          col_size: 12,
          obj_name: 'region',
          label: this.$t('objects.region'),
          placeholder: this.$t('objects.region'),
          props: {
            options: this.GET_REGIONS,
            getOptionLabel: option => option.name[this.$i18n.locale],
            reduce: option => option.id,
          },
        },
        {
          component_name: 'v-select',
          col_size: 12,
          obj_name: 'rayon',
          label: this.$t('objects.district'),
          placeholder: this.$t('objects.district'),
          props: {
            options: this.GET_DISTRICTS,
            getOptionLabel: option => option.name[this.$i18n.locale],
            reduce: option => option.id,
            disabled: Boolean(!this.obj.region),
          },
        },
      ]
    },
    // getDescriptionFields() {
    // },
    getInfrastructureFields() {
      return [
        {
          component_name: 'b-form-checkbox-group',
          col_size: 6,
          obj_name: 'infrastructure',
          props: {
            options: this.GET_OBJECT_INFRASTRUCTURES,
            stacked: true,
            'text-field': `title.${this.$i18n.locale}`,
            'value-field': 'id',
          },
        },
        // {
        //   component_name: 'b-form-checkbox-group',
        //   obj_name: 'parking',
        //   col_size: 6,
        //   label: this.$t('objects.parking_space'),
        //   props: {
        //     class: 'mt-50',
        //     options: this.GET_PARKING_OPTIONS,
        //     stacked: true,
        //     'text-field': `title.${this.$i18n.locale}`,
        //     'value-field': 'id',
        //   },
        // },
      ]
    },
    getLocale() {
      const locale = this.$i18n.locale || 'uz'
      return locale
    },
  },
  watch: {
    'obj.region': function () {
      this.FETCH_DISTRICTS({ region: this.obj.region })
    },
    'obj.brand': function (newVal) {
      this.FETCH_ONE_CONSTRUCTOR(newVal)
    },
  },
  created() {
    this.FETCH_OBJECT_TYPES()
    this.FETCH_CURRENCIES()
    this.FETCH_PROJECT_STAFF()
    this.FETCH_OBJECT_INFRASTURCTURES()
    this.FETCH_PARKING_OPTIONS()
    this.FETCH_REGIONS({ region: 0, page_size: 20 })
    this.FETCH_SALE_OFFICES()
    this.FETCH_CONSTRUCTORS()
    this.refresh()
    // this.FETCH_CONTENT_TYPE({ app_label: 'cr_objects', model: 'rcobject' }).then(resp => {
    //   this.content_type_id = resp.data.results[0].id
    //   console.log(this.content_type_id)
    // })
  },
  methods: {
    ...mapActions('objects', ['FETCH_ONE_OBJECT', 'FETCH_OBJECT_TYPES', 'EDIT_OBJECT', 'FETCH_OBJECT_INFRASTURCTURES', 'FETCH_PARKING_OPTIONS']),
    ...mapActions('knowledgeBase', ['FETCH_REGIONS', 'FETCH_DISTRICTS', 'FETCH_CURRENCIES', 'FETCH_CONTENT_TYPE', 'FETCH_SALE_OFFICES',
      'FETCH_CONSTRUCTORS', 'FETCH_ONE_CONSTRUCTOR', 'FETCH_PROJECT_STAFF']),
    ...mapActions('files', ['ADD_ATTACHMENT', 'FETCH_ONE_ATTACHMENT', 'DELETE_ATTACHMENT']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    updateBreadcrumb() {
      const [first, second, third] = this.$_removeObjectConnection(this.$route.meta.breadcrumb)
      second.text = this.GET_ONE_OBJECT.title
      second.to = second.to.replace(':id', this.$route.params.id)
      this.UPDATE_BREADCRUMB([first, second, third])
    },
    parkingChange(opt) {
      console.log(opt)
      if (opt.length > 1 && opt.includes(1)) {
        this.obj.parking = [1]
      }
    },
    setNewLocation(pos) {
      console.log(pos)
      this.obj.position = pos
    },
    refresh() {
      this.FETCH_ONE_OBJECT(this.$route.params.id).then(() => {
        this.obj = this.GET_ONE_OBJECT
        this.updateBreadcrumb()
      })
    },
    mapSaved() {
      console.log(this.GET_ONE_OBJECT)
      console.log(this.obj)
    },
    saveObject() {
      console.log(this.GET_ONE_OBJECT)
      this.$refs.editForm.validate().then(success => {
        if (success) {
          const {
            position, region, rayon, file, image, payment_type, ...rest
          } = this.GET_ONE_OBJECT
          const objData = {
            latitude: position.lat,
            longitude: position.lng,
            region: rayon || region,
            ...rest,
          }
          // const fd = new FormData()
          // fd.append('author', useJwt.getUserData().id)
          // fd.append('file', file)
          // fd.append('content_type', this.content_type_id)
          // fd.append('object_id', this.$route.params.id)
          this.EDIT_OBJECT(objData).then(() => {
            // this.refresh()
            this.$_successToast(this.$t('generals.changed'))
            this.$router.push({ name: 'object-view', params: { id: this.$route.params.id } })
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
          // this.ADD_ATTACHMENT(fd).then().catch(err => {
          //   console.log(err)
          // })
        }
      })
    },
    updateImage() {
      this.$refs.imageFileInput.$el.click()
    },
    deleteImage() {
      this.EDIT_OBJECT({ image: null, id: this.GET_ONE_OBJECT.id }).then(this.GET_ONE_OBJECT.image = null)
    },
    fileChanged() {
      console.log(this.obj.file)
      if (this.GET_ONE_OBJECT.file) {
        const fd = new FormData()
        // fd.append('author', useJwt.getUserData().id)
        fd.append('image', this.GET_ONE_OBJECT.file)
        // fd.append('content_type', this.content_type_id)
        fd.append('id', this.$route.params.id)
        this.EDIT_OBJECT(fd).then(resp => {
          this.obj.image = resp.data.image
        }).catch(err => {
          console.log(err)
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-checkbox, .custom-radio{
  margin-bottom: 10px;
}
</style>
